import {useMemo} from 'react'
import {useSelector} from "react-redux";
import {find, sortBy} from "lodash/collection";
import {getQueryLinkParams} from "../../helpers/routing-helper";

// Селективные селекторы для избежания лишних рендеров
const selectLotsData = state => state.lots.lotsData;
const selectPhrases = state => state.lots.phrases;
const selectAllCategories = state => state.lots.all_categories;
const selectXenOptions = state => state.lots.xenOptions;
const selectUserSortData = state => state.lots.user_sort_data;
const selectVisitor = state => state.lots.visitor;
const selectTimeWaitPay = state => state.lots.time_wait_pay;
const selectTimeWaitTake = state => state.lots.time_wait_take;
const selectTimeWaitSend = state => state.lots.time_wait_send;
const selectUserId = state => state.lots.user_id;
const selectChangeLots = state => state.modal.changeLots;

const useLotListFn = () => {
    // Разделенные селекторы для уменьшения количества рендеров
    const lotsData = useSelector(selectLotsData);
    const phrases = useSelector(selectPhrases);
    const all_categories = useSelector(selectAllCategories);
    const xenOptions = useSelector(selectXenOptions);
    const user_sort_data = useSelector(selectUserSortData);
    const visitor = useSelector(selectVisitor);
    const time_wait_pay = useSelector(selectTimeWaitPay);
    const time_wait_take = useSelector(selectTimeWaitTake);
    const time_wait_send = useSelector(selectTimeWaitSend);
    const user_id = useSelector(selectUserId);
    const changeLots = useSelector(selectChangeLots);

    const {type, user_lots_type, year} = useMemo(() => getQueryLinkParams(), []);

    const auction_categories = useMemo(() => {
        if (!all_categories || all_categories.length === 0) return [];
        return sortBy(all_categories, ['parent_category_id', 'display_order']);
    }, [all_categories]);

    const show_img_lots_list = useMemo(() => {
        if (!user_sort_data || user_sort_data.length === 0) return false;
        const obj = find(user_sort_data, {user_lots_type, type});
        return obj?.show_img_lots_list || false;
    }, [user_sort_data, user_lots_type, type]);

    const promotion_color = useMemo(() => xenOptions?.promotion_color, [xenOptions]);

    return {
        promotion_color,
        show_img_lots_list,
        auction_categories,
        user_lots_type,
        time_wait_take,
        time_wait_send,
        time_wait_pay,
        changeLots,
        lotsData,
        phrases,
        visitor,
        user_id,
        type,
        year,
    }
}
export default useLotListFn